import React, { useState } from 'react'
import {
  CAlert, CButton, CCard, CCardBody, CCol, CRow, CForm, CFormInput,
  CFormLabel, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody,
  CTableDataCell, CSpinner,
} from '@coreui/react'
import { api, currentUser } from '../api/client'

interface ClienteData {
  clienteCedula: number
  clienteNombre: string
  clienteEstado: string
  clienteObservacion: string
  clienteNegocio: string
  clienteDireccion: string
  clienteBarrioDireccion: string
  clienteCelular: string
  clienteCodeudorNombre: string
  clienteCodeudorCelular: string
  zonaNombre: string
  clienteCreadoPor: string
}

/**
 * Data Siprin — réplica de solicituddatasiprin.cs:48 (SiprinMax GX).
 * Consulta un cliente por cédula y muestra sus datos (no guarda nada).
 */
const DataSiprinPage: React.FC = () => {
  const user = currentUser()
  const empresa = user?.companyId ?? ''
  const [cedula, setCedula] = useState('')
  const [consultando, setConsultando] = useState(false)
  const [cliente, setCliente] = useState<ClienteData | null>(null)
  const [error, setError] = useState('')

  const consultar = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setCliente(null)
    if (!cedula.trim()) return

    setConsultando(true)
    try {
      const data = await api.get<ClienteData>(
        `/clientes/${encodeURIComponent(cedula)}?empresa=${encodeURIComponent(empresa)}`,
      )
      setCliente(data)
    } catch (err: any) {
      setError('Cliente no encontrado')
    } finally {
      setConsultando(false)
    }
  }

  const filas: [string, string][] = cliente
    ? [
        ['Nombre', cliente.clienteNombre],
        ['Estado', cliente.clienteEstado],
        ['Observacion', cliente.clienteObservacion],
        ['Negocio', cliente.clienteNegocio],
        ['Direccion', cliente.clienteDireccion],
        ['Barrio', cliente.clienteBarrioDireccion],
        ['Celular', cliente.clienteCelular],
        ['Codeudor', [cliente.clienteCodeudorNombre, cliente.clienteCodeudorCelular].filter(Boolean).join(' · ')],
        ['Ruta', cliente.zonaNombre],
        ['Creado Por', cliente.clienteCreadoPor],
      ]
    : []

  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4>DataSiprin</h4>
        </CCol>
      </CRow>

      {error && <CAlert color="danger" dismissible onClose={() => setError('')}>{error}</CAlert>}

      <CCard className="mb-4">
        <CCardBody>
          <CForm onSubmit={consultar}>
            <CRow className="g-3 align-items-end">
              <CCol md={6}>
                <CFormLabel>Consultar Cédula</CFormLabel>
                <CFormInput
                  type="number"
                  placeholder="Cliente Cédula"
                  value={cedula}
                  onChange={(e) => setCedula(e.target.value)}
                />
              </CCol>
              <CCol md={6}>
                <CButton color="primary" type="submit" disabled={consultando}>
                  Consultar
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>

      {consultando && (
        <div className="text-center py-4">
          <CSpinner color="primary" />
        </div>
      )}

      {cliente && (
        <CCard className="mb-4">
          <CCardBody>
            <CTable hover responsive striped>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>Campo</CTableHeaderCell>
                  <CTableHeaderCell>Valor</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {filas.map(([campo, valor]) => (
                  <CTableRow key={campo}>
                    <CTableDataCell className="fw-semibold">{campo}</CTableDataCell>
                    <CTableDataCell>{valor || '—'}</CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CCardBody>
        </CCard>
      )}
    </>
  )
}

export default DataSiprinPage
